function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import cn from 'clsx';
import { string, shape } from 'prop-types';
import { nonNegativeInteger } from 'airbnb-prop-types';
import { designTokenPropTypes } from '@immediate_media/design-tokens';
import Image from '../Image/index.jsx';
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1575v-505h328l17 93c9 50 26 152 39 225l22 134 38-209c21-114 40-216 43-225 4-16 20-18 164-18h159v1010H590l-2-282-3-283-50 280-51 280-80 3-80 3-50-282-49-282-3 282-2 281H0v-505zM870 1575v-505h530v200h-290v210h240v190h-240v220h290v190H870v-505zM1430 1574v-505l208 3c198 3 209 4 249 27 57 33 91 85 120 183 47 164 52 472 8 615-21 69-70 133-125 161-42 21-56 22-252 22h-208v-506zm323 317c35-14 45-54 52-211 7-160-6-344-29-387-13-27-57-53-87-53-5 0-9 149-9 330v330h24c14 0 36-4 49-9zM2080 1575v-505h250v1010h-250v-505zM2363 2073c3-5 51-232 108-506l103-498 120 3 120 3 98 485c53 267 97 493 98 503 0 16-10 17-112 15l-113-3-7-50c-5-27-10-65-13-82l-6-33h-136l-6 60c-13 119-2 110-139 110-65 0-117-3-115-7zm353-460l-21-148-17 110c-9 61-19 127-22 148l-6 37h86l-20-147zM3080 1552c-19-9-42-31-52-48-41-70-42-288-3-364 24-46 70-70 136-70 89 0 139 54 139 150v40h-109l-7-45c-5-38-10-45-29-45-15 0-25 8-29 23-9 36-7 223 4 251 20 55 60 16 60-60v-34h123l-7 58c-13 110-62 162-151 162-22 0-56-8-75-18zM3340 1520v-40h240v80h-240v-40zM3391 1427c-47-23-66-73-66-172 0-134 37-185 135-185 94 0 133 54 133 185 0 132-39 185-135 185-24 0-54-6-67-13zm93-121c11-62-3-150-25-154-11-2-18 7-23 29-16 80 0 185 27 176 6-2 16-25 21-51zM0 510V0h240v1020H0V510zM310 510V0h328l12 68c6 37 23 138 38 226l28 159 38-209c21-115 40-217 43-226 4-16 20-18 164-18h159v1020H900l-1-292V435l-54 290c-30 160-54 291-55 293 0 1-35 2-78 2h-78l-51-287-51-288-1 288-1 287H310V510zM1190 510V0h329l6 33c3 17 21 118 39 222l33 190 11-55c13-60 72-379 72-386 0-2 72-4 160-4h160v1020h-220l-2-282-3-283-49 270c-27 149-51 276-54 283-3 9-25 12-80 10l-76-3-52-285-52-285-1 288-1 287h-220V510zM2080 510V0h560v200h-320v210h260v200h-260v210h320v200h-560V510zM2680 509V-2l203 4c183 3 206 5 242 25 53 28 79 57 109 123 41 92 59 214 59 400-2 248-37 364-132 427-55 37-96 43-293 43h-188V509zm330 311c10-5 23-24 29-41 15-42 15-460 0-514-14-52-45-85-80-85h-28l-3 325-3 325h33c18 0 42-4 52-10zM3330 510V0h250v1020h-250V510zM3610 1010c0-11 198-968 206-992 5-16 20-18 123-18h118l97 487c54 269 100 498 103 511 5 22 4 22-110 22h-114l-6-27c-3-16-9-56-13-90l-7-63h-135l-12 73c-19 117-6 107-136 107-66 0-114-4-114-10zm366-352c-3-18-11-73-17-123-7-49-15-96-18-102-4-7-16 48-27 122l-20 135h88l-6-32zM4310 610V200h-190V0h630v200h-190v820h-250V610zM4780 510V0h550v200h-300v210h261l-3 98-3 97-127 3-128 3v209h300v200h-550V510z"
}));
var LogoSVG = function LogoSVG(props) {
  return /*#__PURE__*/React.createElement("svg", props, _ref2);
};
LogoSVG.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg"
};
import { useDesignTokens } from '../../hooks/index.js';

/**
 * CorporateLogo component.
 */
var _ref = /*#__PURE__*/React.createElement(LogoSVG, null);
const CorporateLogo = ({
  className,
  fillColor,
  width,
  logo,
  name
}) => {
  const {
    colors
  } = useDesignTokens();
  const height = width * 0.39; // Calculate height relative to width
  const alt = `${name} Logo`;
  if (logo) {
    return /*#__PURE__*/React.createElement(Image, _extends({}, logo, {
      fluid: true,
      alt: logo.alt || alt,
      srcSetBreakpoints: [width, width * 2, width * 3, width * 4 // Up to 4x the max width
      ],
      sizes: [`${width}px`]
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn('corporate-logo', className)
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 5330 2080",
    style: {
      color: colors[fillColor],
      width: `${width}px`,
      height: `${height}px`
    }
  }, _ref), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, alt));
};
CorporateLogo.defaultProps = {
  className: null,
  logo: null,
  fillColor: 'baseGrey',
  width: 1000,
  name: 'Immediate Media'
};
CorporateLogo.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,
  /** The color of the logo. */
  fillColor: designTokenPropTypes.color,
  /** The width of the logo in pixels. */
  width: nonNegativeInteger,
  /** The logo from settings */
  logo: shape(Image.propTypes),
  /** Corporate name - used to set the alt text of the image if none is provided  */
  name: string
} : {};
export default CorporateLogo;